module.exports = __webpack_public_path__ + "static/media/77570534-AD24-43B2-8623-ECB8849DF4F0-min.ec00ee1d.jpg";